<template>
<b-container  fluid class='metro-view'>

<div v-if="layout == 1">
    <b-row>
        <b-col cols='8'>
            <b-row>
                <b-col>
                    <card>
                        <h4><b-icon icon="diagram-2-fill"></b-icon><span>Metroasemat</span><b-icon icon="columns-gap" class='close-btn' @click="layout = 3"></b-icon></h4>
                        <HelsinkiMetroMap ref="metroMap" :stations="stations" @select="onSelectStations"></HelsinkiMetroMap>
                    </card>
                </b-col>
            </b-row>
            
            <transition name="fade" mode="out-in">

            <b-row v-if="selectedStations.length == 0" class='charts'>
                <b-col cols="4">
                     
                    <circle-chart-card :percentage="displaysOnlinePercentage" color="green" description="Laiturinäyttöjen tilanne" class='ok'> 
                        <template slot="header"><h4><b-icon icon="check-square-fill"></b-icon><span>Näyttöjen toiminta - nyt</span></h4></template>
                        <template slot="footer"><div class="legend"><b-icon icon="circle-fill" color="green"></b-icon>ONLINE</div></template>
                    </circle-chart-card>
                </b-col>
                 <b-col cols="4">
                    <card>
                        <h4><b-icon icon="bar-chart-line-fill"></b-icon><span>Näyttöjen toiminta - 7 vrk</span></h4>
                        <bar-chart :labels="previousDates" :datasets="departuresChart.datasets"></bar-chart>
                    </card>
                </b-col>
                 <b-col cols="4">
                    <card>
                          <ErrorLog />
                    </card>
                </b-col>
            </b-row>

            <b-row v-if="selectedStations.length > 0">
                <b-col>
                    <card id='metro-stations'>
                        <div v-for="station in stations" :key=station.id>
                            <MetroStation v-if="isSelected(station)" :station="station" @close="onCloseStation"></MetroStation>
                        </div>
                    </card>
                </b-col>
            </b-row>

            </transition> 

        </b-col>
        
        <b-col cols='4'>
            <b-row v-if='!destinationEditorMode'> 
                <b-col>
                    <card>
                        <MetroPassengerInformation :stations="stations" @editorMode="infoEditorMode = true" @listMode="infoEditorMode = false"/>
                    </card>
                </b-col>
            </b-row>

           <b-row v-if='!infoEditorMode'> 
                <b-col>
                    <card>
                        <Destinations :stations="stations" @editorMode="destinationEditorMode = true" @listMode="destinationEditorMode = false"/>
                    </card>
             </b-col>
            </b-row>


        </b-col>
    </b-row>
</div>

<div v-if="layout == 2">
    <b-row>
        <b-col cols="9">
            <b-row>
                <b-col>
                    <card>
                        <h4><b-icon icon="diagram-2-fill"></b-icon><span>Metroasemat</span><b-icon icon="columns-gap" class='close-btn' @click="layout = 1"></b-icon></h4>
                        <HelsinkiMetroMap ref="metroMap" :stations="stations" @select="onSelectStations"></HelsinkiMetroMap>
                    </card>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col cols="6">
                    <card>
                        <MetroPassengerInformation :stations="stations" @editorMode="infoEditorMode = true" @listMode="infoEditorMode = false"/>
                    </card>
                </b-col>
                <b-col cols="6">
                    <card>
                        <Destinations :stations="stations" @editorMode="destinationEditorMode = true" @listMode="destinationEditorMode = false"/>
                  
                    </card>
                </b-col>
            
            </b-row>
            
        </b-col>

        <b-col cols='3'>
            <b-row>
                <b-col>
                    <circle-chart-card :percentage="displaysOnlinePercentage" color="green" description="Laiturinäyttöjen tilanne" class='ok'> 
                    <template slot="header"><h4><b-icon icon="check-square-fill"></b-icon><span>Näyttöjen toiminta - nyt</span></h4></template>
                    <template slot="footer"><div class="legend"><b-icon icon="circle-fill" color="green"></b-icon>ONLINE</div></template>
                    </circle-chart-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <card>
                        <ErrorLog /> 
                    </card>                  
                </b-col>
            </b-row>
        </b-col>
     </b-row>
</div>

<div v-if="layout == 3">
    <b-row v-if="!infoEditorMode && !destinationEditorMode">
        <b-col cols="10">
            <b-row>
                <b-col>
                    <card>
                        <h4><b-icon icon="diagram-2-fill"></b-icon><span>Metroasemat</span><b-icon icon="columns-gap" class='close-btn' @click="layout = 2"></b-icon></h4>
                        <HelsinkiMetroMap ref="metroMap" :stations="stations" @select="onSelectStations"></HelsinkiMetroMap>
                    </card>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="2">
            <circle-chart-card :percentage="displaysOnlinePercentage" color="green"  description="Laiturinäyttöjen tilanne" class='online-chart'> 
                <template slot="header">
                    <h4><b-icon icon="check-square"></b-icon><span>Toiminta nyt</span></h4>
                    <div>Laiturinäytöt</div>
                </template>
                <template slot="footer">
                    <div class="legend"><b-icon icon="circle-fill" color="green"></b-icon>97 / 102</div>
                    <hr>
                    <div class='updated'><b-icon icon="arrow-clockwise"></b-icon>Päivitetty: {{ currentTime }}</div>

                    </template>
            </circle-chart-card>
        </b-col>            
    </b-row>
     <b-row v-if="selectedStations.length == 0">
        <b-col v-show="!destinationEditorMode" :cols="infoEditorMode ? 12 : 6" >
            <card>
                <MetroPassengerInformation :stations="stations" @editorMode="infoEditorMode = true" @listMode="infoEditorMode = false"/>
            </card>
        </b-col>
        <b-col v-show="!infoEditorMode" :cols="destinationEditorMode ? 12 : 4">
            <card>
                <Destinations :stations="stations" @editorMode="destinationEditorMode = true" @listMode="destinationEditorMode = false"/>
            </card>
        </b-col>  
        <b-col v-if="!infoEditorMode && !destinationEditorMode" cols="2"> 
            <card>
                <ErrorLog /> 
            </card>     
        </b-col>         
    </b-row>
    <b-row v-if="selectedStations.length > 0">
        <b-col cols="12">
            <card id='metro-stations'>
                <div v-for="station in stations" :key=station.id>
                    <MetroStation v-if="isSelected(station)" :station="station" @close="onCloseStation"></MetroStation>
                </div>
            </card>
        </b-col>
        <!--b-col cols="2"> 
            <card>
                <ErrorLog /> 
            </card>     
        </b-col-->    
    </b-row>
</div>
</b-container>






</template>

<script>
import HelsinkiMetroMap from '@/components/Metro/HelsinkiMetroMap.vue'
import MetroStation from '@/components/Metro/MetroStation.vue'
//import MetroDisruptions from '@/components/Metro/MetroDisruptions.vue'
//import MetroTrafficModel from '@/components/Metro/MetroTrafficModel.vue'
import MetroPassengerInformation from '@/components/Metro/MetroPassengerInformation.vue'
import ErrorLog from '@/components/Metro/ErrorLog.vue'
import Destinations from '@/components/Metro/Destinations.vue'

import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard'

import BarChart from 'src/components/UIComponents/Charts/BarChart'

import moment from "moment";

export default ({
    name: 'MetroView',
    components: {
        HelsinkiMetroMap, 
        MetroStation,
        MetroPassengerInformation,
        ErrorLog,
        Destinations,
        //MetroDisruptions,
        //MetroTrafficModel,
        CircleChartCard, BarChart
    },
    data: function() {
        return  {
            layout: 3,
            infoEditorMode: false,
            destinationEditorMode: false,
            stations: [
                { id: 1, code: "KVH", name : "Kivenlahti", name_se: "Stensvik", platforms: 2, lines: ["M1"], info: true},
                { id: 2, code: "ESL", name : "Espoonlahti", name_se: "Esboviken", platforms: 2, lines: ["M1"], info: true },
                { id: 3, code: "SOU", name : "Soukka", name_se: "Sökö", platforms: 2, lines: ["M1"], info: true },
                { id: 4, code: "KTA", name : "Kaitaa", name_se: "Kaitans", platforms: 2, lines: ["M1"], info: true },
                { id: 5, code: "FIN",  name : "Finnoo", name_se: "Finno", platforms: 2, lines: ["M1"], status: "error" },
                { id: 6, code: "MAT",  name : "Matinkylä", name_se: "Mattby", platforms: 2, lines: ["M1"] },
                { id: 7, code: "NK", name : "Niittykumpu", name_se: "Ängskulla", platforms: 2, lines: ["M1"], state: 'off'  },
                { id: 8, code: "URP", name : "Urheilupuisto", name_se: "Urheilupuisto", platforms: 2, lines: ["M1"] },
                { id: 9, code: "TAP", name : "Tapiola", name_se: "Hagalund", platforms: 2, lines: ["M1","M2"], info: true },
                { id: 10, code: "AAY", name : "Aalto-yliopisto", name_se: "Aalto-universitet", platforms: 2, lines: ["M1","M2"] },
                { id: 11, code: "KLN", name : "Keilaniemi", name_se: "Kägeludden", platforms: 2, lines: ["M1","M2"], status: "error" },
                { id: 12, code: "KOI", name : "Koivusaari", name_se: "Björkholmen", platforms: 2, lines: ["M1","M2"] },
                { id: 13, code: "LTS", name : "Lauttasaari", name_se: "Drumsö", platforms: 2,lines: ["M1","M2"] },
                { id: 14, code: "RL", name : "Ruoholahti", name_se: "Gräsviken", platforms: 2, lines: ["M1","M2"] },
                { id: 15, code: "KP", name : "Kamppi", name_se: "Kampen", platforms: 2, lines: ["M1","M2"] },
                { id: 16, code: "RT", name : "Rautatientori", name_se: "Järnvägstorget", platforms: 2, lines: ["M1","M2"] },
                { id: 17, code: "HY", name : "Helsingin yliopisto", name_se: "Helsingfors universitet", platforms: 2, lines: ["M1","M2"] },
                { id: 18, code: "HT", name : "Hakaniemi", name_se: "Hagnäs", platforms: 2, lines: ["M1","M2"], status: "warning" },
                { id: 19, code: "SN", name : "Sörnäinen", name_se: "Sörnäs", platforms: 2, lines: ["M1","M2"] },
                { id: 20, code: "KLA", name : "Kalasatama", name_se: "Fiskehamnen", platforms: 2, lines: ["M1","M2"] },
                { id: 21, code: "KUS", name : "Kulosaari", name_se: "Brändö", platforms: 2, lines: ["M1","M2"] },
                { id: 22, code: "HNT", name : "Herttoniemi", name_se: "Hertonäs", platforms: 2, lines: ["M1","M2"] },
                { id: 23, code: "ST", name : "Siilitie", name_se: "Igelkottsvägen", platforms: 2, lines: ["M1","M2"] },
                { id: 24, code: "ITK", name : "Itäkeskus", name_se: "Östra centrum", platforms: 3, lines: ["M1","M2"] },
                { id: 25, code: "MYP", name : "Myllypuro", name_se: "Kvarnbäcken", platforms: 2, lines: ["M2"] },
                { id: 26, code: "KON", name : "Kontula", name_se: "Gårdsbacka", platforms: 2, lines: ["M2"] },
                { id: 27, code: "ML", name : "Mellunmäki", name_se: "Mellungsbacka", platforms: 2, lines: ["M2"] },
                { id: 28, code: "PT", name : "Puotila", name_se: "Botby gård", platforms: 2, lines: ["M1"] },
                { id: 29, code: "RAS", name : "Rastila", name_se: "Rastböle", platforms: 2, lines: ["M1"] },
                { id: 30, code: "VS", name : "Vuosaari", name_se: "Nordsjö", platforms: 2, lines: ["M1"] }
            ],
            
            selectedStations : [],
            
            trafficModels: [
                { id: 0, 
                  name: "Normaaliliikenne",  
                  description: "Liikenne ajetaan normaalisti", 
                },
                { id: 1, 
                  name: "Totaalikatko", 
                  description: "Metroa ei voida liikennöidä millään osuudella", 
                  variants: [ 
                    { id: 1, name: "Metroliikenteen keskeyttäminen kokonaan" },
                    { id: 2, name: "Metroliikennettä ei aloiteta" }
                ]},
                
                { id: 2, 
                  name: "Harvennettu liikenne", 
                  description: "Esimerkiksi kuljettaja- tai kalustopula tai välityskykyyn vaikuttava pitkäkestoinen turvalaitevika", 
                  variants : [ 
                    { id: 1, name: "Runko-osuuden vuoroväli 3 minuuttia" },
                    { id: 2, name: "Runko-osuuden vuoroväli 3,75 minuuttia" },
                    { id: 3, name: "Runko-osuuden vuoroväli 5 minuuttia" },
                    { id: 4, name: "Runko-osuuden vuoroväli 7,5 minuuttia" },
                    { id: 5, name: "Runko-osuuden vuoroväli 10 minuuttia" }
                ]},

                { id: 3, 
                  name: "YRA-liikenne", 
                  description: "Häiriökohde ohitettavissa normaalisti yksittäisellä YRA-toiminnolla", 
                  variants: [ 
                    { id: 1, name: "YRA-alue välillä KIL-TAP" },
                    { id: 2, name: "YRA-alue välillä TAP-RL" },
                    { id: 3, name: "YRA-alue välillä RL-IK" }, 
                    { id: 4, name: "YRA-alue välillä IK-VS/MM" }

                ]},

                { id: 4, 
                  name: "Osittainen liikenne lännestä", 
                  description: "Molemmat raiteet pois käytöstä tai ylipitkä YRA runko-osuudella", 
                  variants: [ 
                    { id: 1, name: "YRA-alue välillä KIL-TAP" },
                ]},

                { id: 5, 
                  name: "Osittainen liikenne idästä", 
                  description: "Molemmat raiteet pois käytöstä tai ylipitkä YRA runko-osuudella", 
                  variants: [ 
                    { id: 1, name: "YRA-alue välillä KIL-TAP" },
                ]},

                { id: 6, 
                  name: "Muut häiriötapaukset", 
                  description: "Häiriö kääntöraiteella tai varikkoliittymässä", 
                  variants: [ 
                    { id: 1, name: "Kivenlahden kääntöraide pois käytöstä" },
                    { id: 2, name: "Tapiolan kääntöraide pois käytöstä" },
                    { id: 3, name: "Mellunmäen kääntöraide pois käytöstä" },
                    { id: 4, name: "Vuosaaren kääntöraide pois käytöstä" },
                    { id: 5, name: "KIL-varikkoliittymä pois käytöstä" },
                    { id: 6, name: "MV-varikkoliittymä pois käytöstä" },
                ]}
            ],
            departuresChart: {
                labels: ["...", "...", "...", "...", "...", "...", "...", "...", "...", "..."],
                datasets: [
                    {
                        label: "ONLINE",
                        borderColor: '#228B22',
                        fill: true,
                        backgroundColor: '#228B22',
                        hoverBorderColor: '#228B22',
                        borderWidth: 5,
                        data: [95, 90, 96, 91, 96, 96, 95]
                    },
                    {
                        label: "OFFLINE",
                        borderColor: '#D22B2B',
                        fill: true,
                        backgroundColor: '#D22B2B',
                        hoverBorderColor: '#D22B2B',
                        borderWidth: 5,
                        data: [3, 8, 2, 7, 2, 2, 2]
                    }
                ]
            }
        }
    },

    created(){
        this.$sidebar.toggleMinimize()    
    },
    
    computed: {
        displaysOnlinePercentage(){
            return 95;
        },
        previousDates(){
            let date = moment();
         
            let dates = [];
            for (let i = 0; i < 7; i++) {
                date = date.subtract(1, "days");
                dates.push ( date.format("D.M.") );
            }
           
            return dates.reverse();
        },
        currentTime(){
            return moment().format("HH:mm:ss");
        },

    },
    
    methods: {

        isSelected(station){
            return this.selectedStations.length == 0 || this.selectedStations.includes(station);
        },
        onSelectStations(selectedStations){
           this.selectedStations = selectedStations;
        },
        onCloseStation(id){
            //this.selectedStations = this.selectedStations.filter(station => station.id != id);
            this.$refs.metroMap.unselect(id);
        },
        passengerInformationEditor(){
            this.passengerInformationEditor = true;
        }
    }
})
</script>

